<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import UsersTable from './UsersTable';

export default {
  page: {
    title: 'Contacts',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, UsersTable },
  data() {
    return {
      title: 'Contacts',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Contacts', active: true, },
      ],
      
      loading: true,
    }
  },
  created() {

  },
  methods: {
    
  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <UsersTable ref="UsersTable" @loadchange="(e) => {loading = e;}"></UsersTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
